// extracted by mini-css-extract-plugin
export default {"form":"styles_form__vB7Bs","container":"styles_container__v+cop","upsertContent":"styles_upsertContent__XR-RM","buttonWrapper":"styles_buttonWrapper__0J3GT"};